import { atom } from 'jotai';

import { LocaleCode, ParameterNode, UserPreferredUnit } from '@data';

import { activityAtom } from '../activity/activity';

export const DEFAULT_USER_SETTINGS_WITH_NULL = {
    settings: {},
    locale: 'en' as LocaleCode,
    userPreferredUnit: 'metric' as UserPreferredUnit,
    showCorridors: false,
    showGoal: true,
    activeLayoutId: null,
};

export const goalCorridorParameterAtom = atom<ParameterNode | null>();

export const setGoalCorridorParameterAtom = atom(null, (get, set, payload?: ParameterNode | null) => {
    if (!get(activityAtom)?.layoutId) {
        set(goalCorridorParameterAtom, null);
        return;
    }
    set(goalCorridorParameterAtom, payload);
});
